/*
* AGP events
* Editeur
*/

// import $ from "jquery";
// import tinymce from 'tinymce';
// import 'tinymce/icons/default';
// import 'tinymce/themes/silver';
// import 'tinymce/models/dom';
// import 'tinymce/skins/ui/oxide/skin.css';
//
// import 'tinymce/plugins/advlist';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/emoticons';
// import 'tinymce/plugins/emoticons/js/emojis';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/lists';
// import 'tinymce/plugins/table';
// import 'tinymce/plugins/media';
// import 'tinymce/plugins/image';
// import 'tinymce/plugins/autosave';
//
// import contentUiSkinCss from 'tinymce/skins/ui/oxide/content.css';
// import contentCss from 'tinymce/skins/content/default/content.css';

/* Import content css */
// import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
// import contentCss from 'tinymce/skins/content/default/content.css';


// import "../AGP/PLUGS/tinymce/js/tinymce/tinymce.min.js";
// import "../AGP/PLUGS/tinymce/js/tinymce/themes/modern/theme.min.js";
// import "../AGP/PLUGS/tinymce_6/plugins/advlist/plugin.min.js";
// import "../AGP/PLUGS/tinymce_6/plugins/lists/plugin.min.js";
// import '../AGP/PLUGS/tinymce_6/icons/default/icons.min.js';
// import '../AGP/PLUGS/tinymce_6/themes/silver/theme.min.js';
// // import '../AGP/PLUGS/tinymce_6/skins/ui/oxide/content.min.css';
// // import "../AGP/PLUGS/tinymce_6/skins/ui/oxide/skin.min.css";
// import "../AGP/PLUGS/multiple-select/dist/multiple-select-locale-all.js";

export function render () {
    tinymce.init({
        selector: '.textarea-mce',
        plugins: 'advlist code emoticons link lists table',
        toolbar: 'bold italic | bullist numlist | link emoticons',
        skin: false,
        content_css: false,
        //content_style: contentUiSkinCss.toString() + '\n' + contentCss.toString(),
    });
};


export default class Editor {


    init() {

        tinymce.init({
            selector: ".textarea-mce",
            skin: 'oxide',
            height: 550,
            menubar: false,
            paste_text_sticky: true,
            branding: false,
            schema: 'html5',
            oninit: "setPlainText",
            paste_as_text: true,
            force_br_newlines: true,
            block_unsupported_drop: false,
            image_title: true,
            /* enable automatic uploads of images represented by blob or data URIs*/
            automatic_uploads: true,
            file_picker_types: 'image',
            /* and here's our custom image picker*/
            file_picker_callback: function (cb, value, meta) {
                var input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');

                /*
                  Note: In modern browsers input[type="file"] is functional without
                  even adding it to the DOM, but that might not be the case in some older
                  or quirky browsers like IE, so you might want to add it to the DOM
                  just in case, and visually hide it. And do not forget do remove it
                  once you do not need it anymore.
                */

                input.onchange = function () {
                    var file = this.files[0];

                    var reader = new FileReader();
                    reader.onload = function () {
                        /*
                          Note: Now we need to register the blob in TinyMCEs image blob
                          registry. In the next release this part hopefully won't be
                          necessary, as we are looking to handle it internally.
                        */
                        var id = 'blobid' + (new Date()).getTime();
                        var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);

                        /* call the callback and populate the Title field with the file name */
                        cb(blobInfo.blobUri(), {title: file.name});
                    };
                    reader.readAsDataURL(file);
                };

                input.click();
            },
            //force_p_newlines: false,
            //forced_root_block: '',
            //body_class: "mceContentBody",
            textcolor_map: [
                "895BED", "Violet",
                "F78E6F", "Corail",
                "0D2833", "Gris foncé",
                "DCE0E3", "Gris médium",
                "BFC6CB", "Gris clair",
                "000", "Noir"
            ],
            setup: function (editor) {
                editor.on('change', function (e) {
                    editor.save();
                });
            },
            plugins: 'advlist code link lists table image media autosave',
            toolbar: 'bold italic underline | bullist numlist | image | media | link | autosave',
            // plugins: [
            //     "code"
            // ],
            // //toolbar: "code removeformat | forecolor backcolor | bold italic underline | bullist | link"
            // toolbar: "code table"
        });

        tinymce.init({
            selector: ".textarea-middle",
            skin: 'oxide',
            height: 300,
            menubar: false,
            paste_text_sticky: true,
            branding: false,
            schema: 'html5',
            oninit: "setPlainText",
            paste_as_text: true,
            force_br_newlines: true,
            block_unsupported_drop: false,
            image_title: true,
            textcolor_map: [
                "895BED", "Violet",
                "F78E6F", "Corail",
                "0D2833", "Gris foncé",
                "DCE0E3", "Gris médium",
                "BFC6CB", "Gris clair",
                "000", "Noir"
            ],
            setup: function (editor) {
                editor.on('change', function (e) {
                    editor.save();
                });
            },
            plugins: 'advlist code link lists table image media autosave',
            toolbar: 'code | bold italic underline | bullist ilink | autosave'
        });


        // console.log(tinymce);
        //
        // tinymce.init({
        //     selector: '.textarea-title',
        //     skin: "custom_adm",
        //     skin: false,
        //     plugins: 'lists advlist',
        // });

        //
        // tinymce.init({
        //     selector: 'textarea#editor',
        //     plugins: 'advlist code link lists table',
        //     toolbar: 'bold italic | bullist numlist | link',
        //     skin: false,
        //     content_css: false,
        //     content_style: contentUiCss.toString() + '\n' + contentCss.toString(),
        // });


//         tinymce.init({
//             selector: ".textarea-title",
//             // skin: "custom_adm",
//             height: 350,
//             menubar: false,
//             // branding: false,
//             // relative_urls : false,
//             // schema:'html5',
//             // oninit : "setPlainText",
//             // convert_urls: false,
//             // force_br_newlines : true,
//             //force_p_newlines : false,
//             //forced_root_block : false,
//             //content_css: _URL_FILES + 'stylesheets/SITE/generic_editor.css?' + new Date().getTime(),
//             //body_class: "mceContentBody",
//             textcolor_map: [
//                 "b0bfa1", "Vert",
//                 "ddb86c", "Gold",
//                 "1d355f", "Bleu",
//                 "9f2c2c", "Bordeaux",
//             ],
//             style_formats: [
//                 {
//                     title: 'H2', items: [
//                         {title: "H2 Bleu", block: 'h2', classes: '_hutte_h2'},
//                         {title: "H2 Gold", block: 'h2', classes: '_hutte_h2 _gold'},
//                         {title: "H2 Vert", block: 'h2', classes: '_hutte_h2 _green'}
//                     ]
//                 },
//                 {
//                     title: 'H3', items: [
//                         {title: "H3 Bleu", block: 'h3', classes: '_hutte_h3'},
//                         {title: "H3 Gold", block: 'h3', classes: '_hutte_h3 _gold'},
//                         {title: "H3 Vert", block: 'h3', classes: '_hutte_h3 _green'}
//                     ]
//                 }
//             ],
//             setup: function (editor) {
//                 editor.on('change', function (e) {
//                     editor.save();
//                 });
//             },
//             plugins: [
//                 "code textcolor link lists paste"
//             ],
//             toolbar: "code removeformat | styleselect | forecolor backcolor | bold italic underline | bullist | link"
//         });
//
//         // VERSION SHORT TEXTAREA
//         tinymce.init({
//             selector: ".textarea-short",
//             skin: "custom_adm",
//             height: 350,
//             inline_styles: true,
//             menubar: false,
//             branding: false,
//             oninit: "setPlainText",
//             schema: 'html5',
//             textcolor_map: [
//                 "b0bfa1", "Vert",
//                 "ddb86c", "Gold",
//                 "1d355f", "Bleu",
//                 "9f2c2c", "Bordeaux",
//             ], plugins: [
//                 "importcss textcolor advlist autolink lists link image charmap preview anchor",
//                 "searchreplace visualblocks code fullscreen",
//                 "insertdatetime media table contextmenu paste jbimages paste"
//             ], toolbar: "code removeformat | fontsizeselect | forecolor | bold italic underline | bullist | link",
//             relative_urls: false
//         });
//
//
//         // VERSION CUSTOM TEXTAREA
//         tinymce.init({
//             selector: ".textarea",
//             branding: false,
//             oninit: "setPlainText",
// //			paste_text_sticky: true,
// //			paste_text_sticky_default: true,
// //			forced_root_block : "p", //!important
// //			force_br_newlines : false, //!important
// //			force_p_newlines : true, //!important
// //			valid_elements: "br", //!important
// //			paste_as_text: true, //!important
//             menubar: false,
//             height: 450,
//             inline_styles: true,
//             schema: 'html5',
//             min_height: 450,
//             max_height: 700,
//             skin: "custom_adm",
//             content_css: _URL_FILES + 'stylesheets/SITE/generic_editor.css?' + new Date().getTime(),
//             table_class_list: [
//                 {title: '', value: ''},
//                 {title: 'full width', value: '_table_width'}
//             ],
//             style_formats: [
//                 {
//                     title: 'H2', items: [
//                         {title: "H2 Bleu", block: 'h2', classes: '_hutte_h2'},
//                         {title: "H2 Gold", block: 'h2', classes: '_hutte_h2 _gold'},
//                         {title: "H2 Vert", block: 'h2', classes: '_hutte_h2 _green'}
//                     ]
//                 },
//                 {
//                     title: 'H3', items: [
//                         {title: "H3 Bleu", block: 'h3', classes: '_hutte_h3'},
//                         {title: "H3 Gold", block: 'h3', classes: '_hutte_h3 _gold'},
//                         {title: "H3 Vert", block: 'h3', classes: '_hutte_h3 _green'}
//                     ]
//                 }
//             ],
//             'formats': {
//                 'alignleft': {
//                     'selector': 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img',
//                     attributes: {"align": 'left'}
//                 },
//                 'aligncenter': {
//                     'selector': 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img',
//                     attributes: {"align": 'center'}
//                 },
//                 'alignright': {
//                     'selector': 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img',
//                     attributes: {"align": 'right'}
//                 },
//                 'alignfull': {
//                     'selector': 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img',
//                     attributes: {"align": 'justify'}
//                 }
//             },
//             fullscreen_new_window: true,
//             textcolor_map: [
//                 "b0bfa1", "Vert",
//                 "ddb86c", "Gold",
//                 "1d355f", "Bleu",
//                 "9f2c2c", "Bordeaux",
//             ], setup: function (editor) {
//                 editor.on('FullscreenStateChanged', function () {
//                     $("#wrapper").addClass("toggled");
//                     $(".btn-menu").css("left", "0");
//                     $(".btn-menu i").removeClass("fa-close").addClass("fa-bars");
//                 });
//             },
//             fontsize_formats: '0.750em 0.900em 1em 1.2em 1.3em 1.4em 1.6em 1.8em 2em 2.225em 3em 6em',
//             plugins: [
//                 "textcolor advlist autolink lists paste link image charmap preview anchor",
//                 "searchreplace visualblocks code fullscreen",
//                 "insertdatetime media table contextmenu paste jbimages "
//             ],
//             toolbar: "code removeformat | styleselect | forecolor | backcolor | bold italic underline | alignleft aligncenter alignjustify | bullist | jbimages | link | fullscreen",
//             relative_urls: false,
//             media_live_embeds: true
//         });


    }
}